import { Position, Side } from "../../../flyout/types";
import { ContainerProps } from "./types";

export const getListBoxPositions = (
  alignmentFromProps: ContainerProps["listBoxAlignment"] = "start"
) => {
  const sides: Side[] = ["bottom", "top"];

  const positions: Position[] = sides.map((side) => {
    if (alignmentFromProps === "center") {
      return side;
    }

    const position = `${side}-${alignmentFromProps}` as const;

    return position;
  });

  return positions;
};
